var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outlined"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3464,
    height: 104,
    transform: "translate(-2372 -40)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7907 22H9.2093C4.15814 22 2 19.8419 2 14.7907V9.2093C2 4.15814 4.15814 2 9.2093 2H13.8605C14.0225 2 14.1728 2.05709 14.2921 2.152C14.3133 2.16832 14.3338 2.18589 14.3535 2.20465L21.7953 9.64651C21.8482 9.69932 21.8914 9.76028 21.9243 9.82628C21.9726 9.9208 22 10.0274 22 10.1395V14.7907C22 19.8419 19.8419 22 14.7907 22ZM20.6047 10.8372V14.7907C20.6047 19.0791 19.0791 20.6047 14.7907 20.6047H9.2093C4.92093 20.6047 3.39535 19.0791 3.39535 14.7907V9.2093C3.39535 4.92093 4.92093 3.39535 9.2093 3.39535H13.1628V6.4186C13.1628 9.6 14.4 10.8372 17.5814 10.8372H20.6047ZM8.51163 16.6512C8.51163 17.0326 8.82791 17.3488 9.2093 17.3488C9.5907 17.3488 9.90698 17.0326 9.90698 16.6512V12.7535L10.5767 13.4233C10.7163 13.5628 10.893 13.6279 11.0698 13.6279C11.2465 13.6279 11.4233 13.5628 11.5628 13.4233C11.8326 13.1535 11.8326 12.707 11.5628 12.4372L9.73609 10.6105C9.66931 10.5335 9.58519 10.4713 9.48771 10.4314C9.4807 10.4284 9.47365 10.4255 9.46657 10.4227C9.21127 10.3194 8.91418 10.3833 8.72176 10.5713L8.71628 10.5767L6.85582 12.4372C6.58605 12.707 6.58605 13.1535 6.85582 13.4233C7.12558 13.693 7.5721 13.693 7.84186 13.4233L8.51163 12.7535V16.6512ZM14.5581 6.4186V4.3814L19.6186 9.44186H17.5814C15.1814 9.44186 14.5581 8.8186 14.5581 6.4186Z",
    fill: "#1F2328"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.aeedac8306b2261286662edfdc857e00.svg";
export { ForwardRef as ReactComponent };